<template>
    <v-card>
        <v-toolbar flat dense :color="$store.state.UiColors.crudToolbarList">
            <v-icon>list</v-icon>
            <v-toolbar-title class="font-weight-light">Lista de Canales de Venta</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-data-table 
            :headers="headers"
            :items="listaCanalesVenta"
            :server-items-length="totalItems"
            v-model="selectedRow"
            :loading="loading"
            hide-default-footer
        >
            <template slot="no-data">
            <v-alert :value="true" color="grey" icon="warning">
                No se encontraron Canales de Venta para el grupo Selecionado
            </v-alert>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                  <!-- Le pongo la lista en la posicion del id, no se de qúe otra manera bindearlo. -->
                  <td class="text-xs-left">{{ item.tipoCanalVentaDescripcion }}</td>
                  <td class="text-xs-left">{{ item.nombre }}</td>
                  <td class="text-xs-left">{{ item.codigo }}</td>
              </tr>
            </template>
        </v-data-table>
    <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog()">Cerrar</v-btn>
    </v-card-actions>
    </v-card >
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    loading: false,
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
        { text: 'Tipo de Canal Venta', value: 'canalVentaTipo', sortable:false },
        { text: 'Nombre', value: 'canalVentaNombre',sortable: false },
        { text: 'Codigo', value: 'canalVentaCodigo', sortable: false }
      ],       
    listaCanalesVenta: [], // registros
    selectedRow: []
  }),
  props: {
    value: {
      type: Array,
      required: true
    },
    propName:{
        type: String,
        required: true,
        default: 'listaCanalesVenta'
    },
    label: {
      type: String,
      default: 'Lista Canales Venta'
    }
  },
  watch:{
    'value': function(item){
        Vue.$log.debug('editMode' + item);          
        this.setLista();
      }
  },
  computed: {  
  },
  created () {
  },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    setLista(){
      Vue.$log.debug(this.propName);
      Vue.$log.debug(this.value);
      if(!this.value[this.propName]){
            this.listaCanalesVenta = []
            
            this.value[this.propName] = this.listaCanalesVenta
        }
        this.listaCanalesVenta = this.value;
        this.totalItems = this.listaCanalesVenta.length;
        Vue.$log.debug(this.listaCanalesVenta);
    },
    closeDialog: function(){
        this.$emit('close-dialog');        
    },
  },
}

</script>